angular.module('aq.filters.units')
.filter('arrayToTemperatureUnit', function($filter) {
    return function(items, temperatureUnit) {
        return _.map(items, function(i) {
            return $filter('toTemperatureUnit')(i, temperatureUnit);
        })
    }
});